<template>
  <div class="profile">
    <div class="profile__main">
      <span class="avatar">{{ shortName(member.name) }}</span>
      <div>
        <div class="name-line">
          <strong>{{ member.name }}</strong>
          <i class="risk" :class="riskClass(member.risk)">{{ member.risk || '无报告' }}</i>
        </div>
        <p>{{ member.phone || '--' }}</p>
      </div>
    </div>
    <div class="profile__nums">
      <div><strong>{{ member.score }}</strong><span>健康评分</span></div>
      <div><strong>{{ (member.tags || []).length }}</strong><span>动态标签</span></div>
      <div><strong>{{ activeCount }}</strong><span>在用药品</span></div>
    </div>
  </div>
</template>

<script>
/** 会员档案头：评分、已生效标签数、在用药品数 */
import { shortName, riskClass } from '../helpers';

export default {
  name: 'MemberProfile',
  props: {
    member: { type: Object, required: true },
    activeCount: { type: Number, default: 0 }
  },
  methods: { shortName, riskClass }
};
</script>
